import React, { useEffect, Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import GlobalStyles, { theme } from './styles/GlobalStyles';
import Layout from './components/Layout';
import AdminRoute from './components/admin/AdminRoute';

const Home          = lazy(() => import('./pages/Home'));
const Bookings      = lazy(() => import('./pages/Bookings'));
const About         = lazy(() => import('./pages/About'));
const ListYourSpace = lazy(() => import('./pages/ListYourSpace'));
const AdminLogin    = lazy(() => import('./pages/admin/AdminLogin'));
const AdminDashboard = lazy(() => import('./pages/admin/AdminDashboard'));

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <Router>
        <ScrollToTop />
        <Suspense fallback={<div style={{ minHeight: '60vh' }} />}>
          <Routes>
            {/* Admin routes — rendered outside Layout (no nav/footer) */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin/*"
              element={
                <AdminRoute>
                  <AdminDashboard />
                </AdminRoute>
              }
            />

            {/* Public routes — wrapped in Layout */}
            <Route
              path="*"
              element={
                <Layout>
                  <Routes>
                    <Route path="/"               element={<Home />} />
                    <Route path="/listings"       element={<Bookings />} />
                    <Route path="/bookings"       element={<Bookings />} />
                    <Route path="/about"          element={<About />} />
                    <Route path="/list-your-space" element={<ListYourSpace />} />
                  </Routes>
                </Layout>
              }
            />
          </Routes>
        </Suspense>
      </Router>
    </ThemeProvider>
  );
}

export default App;
